export default __webpack_public_path__ + "static/media/locthan.60b45444.png";